module.exports = __webpack_public_path__ + "static/media/hidratacion34k.828c0c35.webp";